import { Injectable } from '@angular/core';

import { BackendOberflaecheService, DownloadService, IDownloadService } from '@vhv/tarifrechner-common';
import { AppConfiguration } from '../app/app.configuration';
import { HttpHeaders } from '@angular/common/http';
import { SendeAntragsdatenBaugeraeteService } from './sende-antragsdaten-baugeraete.service';

@Injectable({
    providedIn: 'root',
})
export class DownloadBaugeraeteService implements IDownloadService {

    constructor(
        private downloadService: DownloadService,
        private _inputBackendOberflaecheService: BackendOberflaecheService,
        private appConfig: AppConfiguration,
        private sendeAntragsdatenBaugeraeteService: SendeAntragsdatenBaugeraeteService
    ) {
        this.downloadService.setDownloadService(this);
    }

    public getHeaders() {
        return new HttpHeaders({
            'Content-Type': 'application/json',
        });
    }

    public getUrl(): string {
        return this.appConfig.restParentPath + this.appConfig.restPaths.pdfGebuendelterDownload.path;
    }

    public getDateiname() {
        return 'Sammeldokument_VHV_Baugeraete.pdf';
    }

    public getFachdaten(): any {
        return this.sendeAntragsdatenBaugeraeteService.getDownloadRequest();
    }

    public getAntragskopie(): string {
        return null;
    }

    public setAntragskopie(jsonBlob: string) {
        return;
    }

    public getAntragskopieDateiname() {
        return 'VHV-Baugeraete-Kopie.pdf';
    }

}
